import React from 'react';
import * as M from '@mui/material';
import _ from 'lodash';
import { useTheme } from '@mui/material';
import * as S from './styles';

const Button = M.styled(M.Button)(({ theme }) => ({
  paddingLeft: '16px',
  paddingRight: '16px',
  paddingTop: '8px',
  paddingBottom: '8px',
  lineHeight: '1.3em',
}));

export default function AxlButton(props) {
  const { icon, tooltip, spacing = 1, padding, noRadius, color, bgcolor, loading = false, minWidth, compact, ...cloneProps } = props;
  const theme = useTheme();
  const customizeStyle = {
    padding: padding || '8px',
    color: _.get(theme.palette, color) || 'inherit',
    backgroundColor: _.get(theme.palette, bgcolor) || 'inherit',
    ...(noRadius ? { borderRadius: 0 } : {}),
    ...(props.variant === 'outlined'
      ? {
          border: `1px solid ${_.get(theme.palette, color)}`,
        }
      : {}),
    ...(icon
      ? {
          minWidth: 'auto',
          position: 'relative',
          padding: padding || '8px 10px',
        }
      : { minWidth: minWidth || 80 }),
  };

  return (
    <M.Box component={`span`} padding={spacing}>
      {props.tooltip ? (
        <M.Tooltip style={{ minWidth: icon ? 'auto' : 80 }} {...tooltip}>
          <Button style={customizeStyle} {...cloneProps}>
            {loading ? <M.CircularProgress size={15} thickness={2} /> : cloneProps.children}
          </Button>
        </M.Tooltip>
      ) : (
        <Button style={customizeStyle} {...cloneProps}>
          {loading ? <M.CircularProgress size={15} thickness={2} /> : cloneProps.children}
        </Button>
      )}
    </M.Box>
  );
}
